module.exports = __webpack_public_path__ + "static/img/121.f55ad3cb.png";